// Auto-generated by scripts/stamp-version.js — do not edit
export const APP_VERSION = '2.7.1';
